import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzAlertModule } from 'ng-zorro-antd/alert';

import { ConfigTiposComponent } from '../conciliadora-config/config-tipos/config-tipos.component';
import { RegistroDetailComponent } from '../conciliadora-main/registro-detail/registro-detail.component';
import { FlowExecutionMonitorComponent } from '../conciliadora-main/flow-execution-monitor/flow-execution-monitor.component';
import { FlowMonitorService } from './services/flow-monitor.service';

@NgModule({
  declarations: [
    ConfigTiposComponent,
    RegistroDetailComponent,
    FlowExecutionMonitorComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzTableModule,
    NzButtonModule,
    NzIconModule,
    NzInputModule,
    NzSelectModule,
    NzFormModule,
    NzGridModule,
    NzSwitchModule,
    NzCardModule,
    NzTagModule,
    NzDividerModule,
    NzTooltipModule,
    NzDrawerModule,
    NzModalModule,
    NzSpinModule,
    NzProgressModule,
    NzEmptyModule,
    NzDatePickerModule,
    NzInputNumberModule,
    NzDescriptionsModule,
    NzSpaceModule,
    NzCollapseModule,
    NzTabsModule,
    NzBadgeModule,
    NzAlertModule,
  ],
  exports: [
    ConfigTiposComponent,
    RegistroDetailComponent,
    FlowExecutionMonitorComponent,
  ],
  providers: [
    FlowMonitorService,
  ],
})
export class ConciliadoraModule {}
